var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextInput } from '../inputs';
export const defaultValidate = (value) => {
    if (value === '') {
        return 'Please enter a username.';
    }
    return undefined;
};
const Username = (_a) => {
    var { validate, useDefaultValidate, name, label = 'Username' } = _a, props = __rest(_a, ["validate", "useDefaultValidate", "name", "label"]);
    const selectedValidation = validate || (useDefaultValidate ? defaultValidate : undefined);
    return (React.createElement(TextInput, Object.assign({ labelContent: label, name: name, inputType: "text", validate: selectedValidation, required: true, "aria-required": true }, props)));
};
export default Username;
//# sourceMappingURL=Username.js.map